<template>
    <div>
        <dd-avatar-and-name
          v-if="hasCustomer"
          :name="customerName"
          :customer-id="customer.id"
          :link-to-customer="true"
          :size="30"
        />
        <div v-else class="flex-row gap-xs align-items-center">
          <BadgeComponent size="lg"/>
          <p class="sender-text">{{ hasCustomer ? customerName : row.from}}</p>
        </div>
    </div>
</template>

<script>
import BadgeComponent from '../BadgeComponent.vue';
import CustomerUtils from '~/util/customer';

export default {
  name: "EmailSubjectCell.vue",
  components:{
    BadgeComponent
  },
  props: {
    cellProps: {
      type: String,
      required: true
    },
    row: {
      type: Object,
      required: true
    },
  },
  computed:{
    hasCustomer(){
      return this.row.customer_id !== null && this.customer !== null;
    },
    customer(){
      return this.row.customer?.data;
    },
    customerName(){
      return CustomerUtils.getFullName(this.customer);
    },
  }
}
</script>
<style>
.avatar-and-name {
  justify-content: flex-start !important;
}
.sender-text{
  margin: 0;
  flex: 1;
  overflow: hidden;
  white-space: nowrap !important;
  text-overflow: ellipsis;
}
</style>
